import { useCallback, useState } from 'react';
import { DeviceIdentificationForm } from '../DeviceIdentificationForm/DeviceIdentificationForm';
import { StyledManualEntry } from './ManualEntry.styles';
import { ManualEntryFooter } from './ManualEntryFooter';
import { useServiceRequestContext } from 'app/modules/service/context/ServiceContext';
import { HelperModal } from 'app/modules/service/modals/HelperModal/HelperModal';
import { IS_DESKTOP } from 'app/modules/service/utils/constants';
import { HelperModalForm } from 'app/modules/service/modals/HelperModal/HelperModal.types';

interface ManualEntryProps {
  onScanBarcode: () => void;
  onValidityChange: (isValid: boolean) => void;
}

export const ManualEntry = ({ onScanBarcode, onValidityChange }: ManualEntryProps): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const footer = !IS_DESKTOP ? <ManualEntryFooter onScanBarcode={onScanBarcode} /> : undefined;

  const { handleAddServiceCaseNext, handleDevice, deviceData } = useServiceRequestContext();

  const handleConfirm = useCallback(
    (values: HelperModalForm) => {
      setIsModalOpen(false);
      onValidityChange(true);
      handleAddServiceCaseNext();
      handleDevice({
        identifiedViaHelper: values,
      });
    },
    [onValidityChange, handleAddServiceCaseNext, handleDevice]
  );

  return (
    <StyledManualEntry>
      <DeviceIdentificationForm
        initialValues={deviceData}
        onValidityChange={onValidityChange}
        showHelpLink
        onHelpLinkClick={(): void => setIsModalOpen(true)}
        footer={footer}
      />

      <HelperModal
        open={isModalOpen}
        onClose={(): void => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        initialValues={deviceData.identifiedViaHelper}
      />
    </StyledManualEntry>
  );
};
